import { render, staticRenderFns } from "./ProductStock.vue?vue&type=template&id=351f5939&scoped=true&"
import script from "./ProductStock.vue?vue&type=script&lang=ts&"
export * from "./ProductStock.vue?vue&type=script&lang=ts&"
import style0 from "./ProductStock.vue?vue&type=style&index=0&id=351f5939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f5939",
  null
  
)

export default component.exports